export default __webpack_public_path__ + "static/media/spuelung.9c2292af.png";